import { conf } from "../conf";
import { OccupiedDay } from "../api/occupied-days";

export const getGroupDataForTable = (tableId: string, groups: string[][]) => {
	let groupIndex = -1;

	if (groups && groups.length) {
		groupIndex = groups.reduce((acc, ids, index) => {
			if (ids.indexOf(tableId) > -1) {
				acc = index;
			}

			return acc;
		}, -1);
	}

	return groupIndex > -1
		? {
				groupIndex,
				color: conf.linkGroupColors[groupIndex]
		  }
		: {};
};

export const getGroupsForDay = (
	days: OccupiedDay[],
	selectedDate: Date
): string[][] => {
	const date = new Date(selectedDate.getTime());
	date.setHours(0, 0, 0, 0);

	const selectedDay = days.find(day => day.date.getTime() === date.getTime());

	return (selectedDay && selectedDay.linkedTables) || [];
};
